import { render, staticRenderFns } from "./CompliancePlanSelection.vue?vue&type=template&id=69232347&scoped=true&"
import script from "./CompliancePlanSelection.vue?vue&type=script&lang=ts&"
export * from "./CompliancePlanSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69232347",
  null
  
)

export default component.exports